/**
 * WCAG relative luminance (sRGB), for picking readable foreground on custom embed backgrounds.
 * @see https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
 */
const channelToLinear = (channel0to255) => {
  const s = channel0to255 / 255
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4
}

export const relativeLuminanceFromRgb = (r, g, b) => {
  const R = channelToLinear(r)
  const G = channelToLinear(g)
  const B = channelToLinear(b)
  return 0.2126 * R + 0.7152 * G + 0.0722 * B
}
